import styled, { css } from 'styled-components';

export const DropdownContainer = styled.div`
  border: 5px solid black;
  position: absolute;
  left: 0;
  right: 0;
  top: 40px;
  max-height: 185px;
  border: 1px solid black;
  border-radius: 4px;
  background-color: white;
  display: flex;
  flex-direction: column;
  overflow: auto;
  z-index: 9999;

  ${(props) =>
    !!props.maxHeight &&
    css`
      max-height: ${props.maxHeight};
    `}
`;
